import axios, { CancelToken } from "axios";

export const login = async ({ username, password }) => {
  const data = new FormData();
  data.append("username", username);
  data.append("password", password);
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_AUTH_API}/auth/login`,
      method: "post",
      headers: { "Content-Type": "application/json" },
      data,
    });
    return {
      token: response.data.access_token,
      refresh_token: response.data.refresh_token,
      user: response.data.user,
    };
  } catch (e) {
    if (e.response.data.errors) {
      return {
        errors: e.response.data.errors.reduce((a, b) => Object.assign(a, b)),
      };
    }
    return {
      errors: {
        username: "Incorrect email and/or password",
        password: "Incorrect email and/or password",
      },
    };
  }
};

export const isAuthenticated = async () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    if (token === null) return {};
    const response = await axios({
      url: `${process.env.REACT_APP_AUTH_API}/auth/me`,
      method: "get",
      headers: { Authorization: `Bearer ${token}` },
    });
    return { user: response.data.data };
  } catch (e) {
    return { detail: e.response };
  }
};

// new company enpoints (without authentication)

export const getCustomers = async (
  query = "",
  cancelToken: CancelToken | undefined = undefined,
  filters?,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  let url = `${process.env.REACT_APP_AUTH_API}/companies?q=${query}`;
  if (filters) {
    url = url.concat(`&filters=${filters}`);
  }
  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const getCustomer = async (customer) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_AUTH_API}/companies/${customer}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const createCustomer = async ({ realm, ...customer }) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_API}/companies?realm=${realm}`,
      headers: { Authorization: `Bearer ${token}` },
      data: customer,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const updateCustomer = async (customer, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "put",
      url: `${process.env.REACT_APP_AUTH_API}/companies/${customer}`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const updateCustomerPermissions = async (customer, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "put",
      url: `${process.env.REACT_APP_AUTH_API}/companies/${customer}/permissions`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const addCustomerToUser = async (userId, companyId, role) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_API}/auth/${userId}/add_company/${companyId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        role,
      },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const removeCustomerFromUser = async (userId, companyId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_API}/auth/${userId}/remove_company/${companyId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const enableAdmin = async (userId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_API}/auth/${userId}/enable_admin`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const disableAdmin = async (userId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_API}/auth/${userId}/disable_admin`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const setCookies = async (data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_API}/auth/me/cookies`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const getCookies = async () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_AUTH_API}/auth/me/cookies`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const refreshToken = (): Promise<any> => {
  const refresh_token = localStorage.getItem("refresh_token");
  if (!refresh_token) return Promise.reject();
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_AUTH_API}/auth/refresh_token`,
    data: { refresh_token },
  })
    .then((response) => {
      document.cookie = `token=${response?.data?.access_token};max-age=432000; path=/;`;
      localStorage.setItem("refresh_token", response?.data?.refresh_token);
      return { data: response.data };
    })
    .catch((e) => {
      return e.response.data;
    });
};
